export default __webpack_public_path__ + "static/media/arrow-next.41770099.svg";